import { useEffect } from 'react';
import { findNearestScrollContainer } from '../utils';

interface UseScrollIntoViewWithPinnedArgs {
  isActive: boolean;
  cellRef: React.RefObject<HTMLElement>;
  pinnedLeftWidth?: number;
  pinnedRightWidth?: number;
}

export const useScrollIntoViewWithPinned = ({
  isActive,
  cellRef,
  pinnedLeftWidth = 0,
  pinnedRightWidth = 0,
}: UseScrollIntoViewWithPinnedArgs) => {
  useEffect(() => {
    if (!isActive || !cellRef.current) return;

    const cell = cellRef.current as HTMLElement;
    const container = findNearestScrollContainer(cell);
    if (!container) return;

    const id = requestAnimationFrame(() => {
      const containerRect = container.getBoundingClientRect();
      const cellRect = cell.getBoundingClientRect();

      const padding = 8;

      const visibleLeft = containerRect.left + pinnedLeftWidth + padding;
      const visibleRight = containerRect.right - pinnedRightWidth - padding;

      let nextScrollLeft = container.scrollLeft;

      const hiddenUnderLeftPinned = cellRect.left < visibleLeft;
      const hiddenUnderRightPinned = cellRect.right > visibleRight;

      if (hiddenUnderLeftPinned) {
        nextScrollLeft -= visibleLeft - cellRect.left;
      } else if (hiddenUnderRightPinned) {
        nextScrollLeft += cellRect.right - visibleRight;
      }

      if (nextScrollLeft !== container.scrollLeft) {
        container.scrollTo({
          left: nextScrollLeft,
          behavior: 'smooth',
        });
      }
    });

    return () => cancelAnimationFrame(id);
  }, [isActive, cellRef, pinnedLeftWidth, pinnedRightWidth]);
};
